<div class="flex">
  <ng-container *ngIf="(authUser$ | async)?.isEmailConfirmed">
    <ng-container *ngIf="sidebarS.isMobileView && isSidebarOpen">
      <div
        class="fixed top-0 right-0 bottom-0 left-0 bg-mdl-bg z-1000"
        (click)="sidebarS.toggleSidebar()"
      ></div>
      <ib-nav
        class="flex justify-between flex-col bg-secondary fixed top-0 left-0 bottom-0 w-sidebar-mob z-1000"
        [@inOutOpacityFromLeft]
      >
      </ib-nav>
    </ng-container>

    <ib-nav
      *ngIf="!sidebarS.isMobileView"
      class="flex justify-between flex-col bg-nav-bg min-h-vh"
      [ngClass]="[
        isSidebarOpen
          ? 'width-sidebar-expand transition-width duration-300 min-w-220px'
          : 'width-sidebar-collapse transition-width duration-300'
      ]"
    >
    </ib-nav>
  </ng-container>

  <div
    class="grow"
    [ngClass]="[
      sidebarS.isMobileView
        ? isSidebarOpen
          ? 'left-sidebar-expand transition-left duration-300'
          : 'left-sidebar-collapse transition-left duration-300'
        : 'left-0'
    ]"
  >
    <ib-auth-header
      *ngIf="(authUser$ | async)?.isEmailConfirmed"
      class="flex justify-between bg-white items-center py-24px px-app-x-m border-b border-border-d h-header"
    ></ib-auth-header>
    <main class="bg-workarea overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<ib-user-idle *ngIf="!tsS.isTouchScreen" (timeIsUp)="logout()"></ib-user-idle>

<div
  *ngIf="logout$ | async"
  class="fixed top-0 right-0 left-0 bottom-0 z-2000 flex justify-center items-center bg-black bg-opacity-80"
>
  <div class="flex justify-center items-start flex-col">
    <ib-spinner [diameter]="30" class="mx-auto"></ib-spinner>
    <div class="mt-40px text-white">Logout...</div>
  </div>
</div>
